import React, { useContext as _useContext, useEffect } from 'react'
import './index.less'
import {
  firstRhythm,
  secondRhythm,
  thirdRhythm,
  fourthRhythm,
  emptyRhythm,
  smallPen
} from '@/assets/images'
import { useAppSelector } from '@/hooks'
import { Rhyme } from '@/features/SetPoemInfo/setPoemInfo'

enum Rhythm {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4
}

export interface cellProps {
  word: string
  rhythm: Rhythm
  abled: boolean
  setAbled: (abled: boolean) => void
  mounted: () => void
}

const Cell = (props: cellProps) => {
  const { word, rhythm, setAbled, mounted, abled } = props
  // 五言诗/七言诗
  const sentenceSelected = useAppSelector((state) => state.poemInfo.scentenceSelected)
  // 诗的挂载动画对象
  const wordAnimationObj = useAppSelector((state) => state.wordAnimation.wordAnimation)
  // 根据rhythm返回svg图片
  const getSVGByRhythm = (rhythm: Rhythm) => {
    switch (rhythm) {
      case Rhythm.ONE:
        return firstRhythm
      case Rhythm.TWO:
        return secondRhythm
      case Rhythm.THREE:
        return thirdRhythm
      case Rhythm.FOUR:
        return fourthRhythm
      default:
        return emptyRhythm
    }
  }
  // 字数的最大索引
  const max_idx = sentenceSelected === Rhyme.FIVE_WORD ? 19 : 27
  // 逐字出现
  useEffect(() => {
    console.log(wordAnimationObj.cur_idx)
    if (max_idx === wordAnimationObj.cur_idx) {
      setAbled(true)
      return
    }
    if (!wordAnimationObj.fade && !wordAnimationObj.show_brush) return
    mounted()
  }, [wordAnimationObj.fade, wordAnimationObj.show_brush, abled])
  return (
    <div
      className='cell'
      style={{
        margin: sentenceSelected === Rhyme.FIVE_WORD ? '0 20px' : '0 10px'
      }}
    >
      <div className='grid'>
        <input
          key={word}
          className={wordAnimationObj.fade ? 'wordAnimation' : 'wordNoAnimation'}
          defaultValue={word}
          type='text'
          disabled
        />
        <img
          className='writingBrush'
          src={smallPen}
          style={{
            display: wordAnimationObj.show_brush ? 'block' : 'none'
          }}
          alt='毛笔'
        />
      </div>
      <div className='rhythm'>
        <img src={getSVGByRhythm(rhythm)} alt='韵律' />
      </div>
    </div>
  )
}

export default Cell
